import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { Tooltip } from "antd";
import SearchIcon from "@mui/icons-material/Search";
import { GetSubAdmindetailsLists } from "../../redux/actions/getSubAdminDetailsListAdminAction";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import Util from "../../validation/index";
import val from "../../getThemeDetails";

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});


const AdminModuleAllocationData = () => {

    const navigate = useHistory();
    const classes = useStyles();
    const [role, setRole] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);
    const [getModuleAllocationResStatus, setGetModuleAllocationResStatus] =
        useState(false);
    const [getModuleAllocationResArray, setGetModuleAllocationResArray] =
        useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [userName, setUserName] = useState("");
    const dispatch = useDispatch();
    const handleChange = ({ target: { name, value } }) => {
        // if (name === "role") {
        //     setRole(value == "Select Role/Sub Role" ? "" : value);
        // }
        if (name === "userName") {
            setUserName(value);
            // Util.verifyAlphabet(value) ? setUserName(value) : setUserName(userName);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;

    const adminGetSubModuleDetailsnRes = useSelector(
        ({ adminGetSubadminDetailsLists }) => adminGetSubadminDetailsLists
    );

    const getModuleAllocationListApi = () => {
        setGetModuleAllocationResStatus(true);
        setIsLoading(true);
        const req = {
            loginDetails: {
                // adminId: "2"
                adminId: val.adminIDS
            },
            userName: userName

        };
        return dispatch(
            GetSubAdmindetailsLists(req, regenerateTokenRes.data.AuthToken)
        );
    };

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getModuleAllocationListApi();
        }
    }, [regenerateTokenRes.data.status]);

    const getModuleAllocationListFunc = () => {
        if (getModuleAllocationResStatus) {
            if (adminGetSubModuleDetailsnRes.data.status == "success") {
                setGetModuleAllocationResArray(
                    [].concat(adminGetSubModuleDetailsnRes.data.moduleAllList)
                );
                setIsLoading(false);
            }
            if (adminGetSubModuleDetailsnRes.data.status == "failed") {
                setGetModuleAllocationResArray(adminGetSubModuleDetailsnRes.data);
                setIsLoading(false);
                if (
                    adminGetSubModuleDetailsnRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminGetSubModuleDetailsnRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (adminGetSubModuleDetailsnRes.data.status == "Failed") {
                setGetModuleAllocationResArray(adminGetSubModuleDetailsnRes.data);
                setIsLoading(false);
                if (
                    adminGetSubModuleDetailsnRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminGetSubModuleDetailsnRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };
    useEffect(() => {
        if (getModuleAllocationResStatus) {
            getModuleAllocationListFunc();
        }
    }, [adminGetSubModuleDetailsnRes.data.status]);

    useEffect(() => {
        if (adminGetSubModuleDetailsnRes.data.status == "Failed") {
            setPage(0);
            if (
                adminGetSubModuleDetailsnRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                adminGetSubModuleDetailsnRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
        if (adminGetSubModuleDetailsnRes.data.status == "failed") {
            setPage(0);
            if (
                adminGetSubModuleDetailsnRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                adminGetSubModuleDetailsnRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [adminGetSubModuleDetailsnRes.data.status]);

    const moduleAllocationHandleClick = (id, role) => {
        navigate.push({
            pathname: `/index/adminModuleAllocationList`,
            search: `?userId=${id}`,
            state: `${role}`
        });
    };

    return (

        <Layout>
            <Card>
                <Grid
                    container
                    spacing={2}
                    style={{ padding: "25px", marginTop: "2rem" }}
                >
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        {/* <TextField
                            select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Role/Sub Role"
                            fullWidth={true}
                            name="role"
                            defaultValue={"Select Role/Sub Role" || role}
                            onChange={handleChange}
                            variant="standard"
                        >
                            <MenuItem
                                value="Select Role/Sub Role"
                                selected="Select Role/Sub Role"
                            >
                                Select Role/Sub Role
                            </MenuItem>
                            <MenuItem value="SubAdmin">SubAdmin</MenuItem>

                        </TextField> */}
                        <TextField
                            autoFocus
                            margin="dense"
                            label="User Name"
                            type="text"
                            fullWidth
                            variant="standard"

                            name="userName"
                            value={userName || ""}
                            onChange={handleChange}
                            InputProps={{
                                sx: {
                                    "&:before": { borderBottomColor: "gray" }, // before focus
                                    "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                            }}
                            InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} container>
                        <Grid>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={getModuleAllocationListApi}
                            >
                                Search <SearchIcon />
                            </CustomButton>
                        </Grid>
                        <Grid item md={7}></Grid>
                    </Grid>
                </Grid>
            </Card>

            {isLoading ? (
                <LoadingSpinner />
            ) : getModuleAllocationResArray.length == undefined ||
                !getModuleAllocationResStatus ? (
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px"
                        }}
                    >
                        <Grid xs={12} sm={12} md={12} lg={12}>
                            <Typography
                                variant="body1"
                                style={{ fontWeight: "700" }}
                                className="themeText"
                            >
                                Module Allocation
                            </Typography>
                        </Grid>

                        <Grid xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="my-3 tableHeaderColor"
                                variant="secondary"
                                style={{ color: "white" }}
                            >
                                No Records Found!
                            </Alert>
                        </Grid>
                    </Grid>
                </Card>
            ) : (
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px"
                        }}
                    >
                        <Grid xs={12} sm={12} md={12} lg={12}>
                            <Typography
                                variant="body1"
                                style={{ fontWeight: "700" }}
                                className="themeText"
                            >
                                Module Allocation
                            </Typography>
                        </Grid>
                        <TableContainer component={Paper} className="my-3">
                            <Table
                                className={classes.table}
                                size="small"
                                aria-label="a dense table"
                            >
                                <TableHead>
                                    <TableRow className="tableHeaderColor">
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Id
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Name
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            User Name
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Email
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Mob No
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Role/Sub Role
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Action
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {getModuleAllocationResArray &&
                                        []
                                            .concat(getModuleAllocationResArray)
                                            .slice(
                                                page * rowsPerPage,
                                                page * rowsPerPage + rowsPerPage
                                            )
                                            .map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell align="center">
                                                        {row.walletOwnerId}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.walletOwnerName}
                                                    </TableCell>
                                                    <TableCell align="center">{row.loginName}</TableCell>
                                                    <TableCell align="center">{row.emailFrom}</TableCell>
                                                    <TableCell align="center">{row.mobile}</TableCell>
                                                    <TableCell align="center">{row.subRole}</TableCell>
                                                    <TableCell align="center">
                                                        {/* <Tooltip title="View">
                                          <CustomButton
                                            style={{
                                              padding: "8px",
                                            }}
                                            onClick={() => viewHandleClickOpen(row)}
                                          >
                                            {
                                              <VisibilityIcon
                                                style={{
                                                  color: "#fff",
                                                  fontSize: "20px",
                                                }}
                                              />
                                            }
                                          </CustomButton>
                                        </Tooltip>
            
                                        <Tooltip title="Edit">
                                          <CustomButton
                                            style={{
                                              padding: "8px",
                                            }}
                                            onClick={() =>
                                              updateEditHandleClick(row, "Edit")
                                            }
                                          >
                                            {
                                              <EditIcon
                                                style={{
                                                  color: "#fff",
                                                  fontSize: "20px",
                                                }}
                                              />
                                            }
                                          </CustomButton>
                                        </Tooltip> */}
                                                        <Tooltip title="Allocate Module">
                                                            <CustomButton
                                                                style={{
                                                                    padding: "8px"
                                                                }}
                                                                onClick={() =>
                                                                    moduleAllocationHandleClick(
                                                                        row.walletOwnerId,
                                                                        row.subRole,
                                                                        "Module"
                                                                    )
                                                                }
                                                            >
                                                                Allocate Module
                                                            </CustomButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={getModuleAllocationResArray.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </TableContainer>
                    </Grid>
                </Card>
            )}
        </Layout>
    )
}
export default AdminModuleAllocationData;